import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(
  () => ({
    layout: {
      // border: '2px solid blue',
    },
    maintext: {
      color: '#6F6F6F',
      fontWeight: 'bold',
    },
    displayTextLayout: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around',
      alignItems: 'center',
      // border: '2px solid red',
      position: 'absolute',
      top: '50%',
      left: '50%',
    },
    sidetext: {
      color: '#6F6F6F',
      fontWeight: 'bold',
      // marginLeft: '20px',
    },
  }),
  { index: 1 },
)

export { useStyles }
